import { MFA_SETUP, MFA_VERIFY_PHONE, PORTAL } from 'portal/constants/Routes';
import { updatePhoneNumber } from 'portal/mfa/MFAApiCalls';
import Link from 'portal/Link';
import React, { useState } from 'react';
import UpdatePhoneComponent from '@opploans/update-phone-component/UpdatePhone';

function UpdatePhone({
  navigate,
  accountLockedPath = PORTAL,
  updateCompletePath = MFA_SETUP
}) {
  const [ssnError, setSsnError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleUpdate(ssn, phoneNumber) {
    setLoading(true);

    const data = await updatePhoneNumber(ssn, phoneNumber);

    if (data?.ok) {
      window.AppConfigState.user_phone_last_four = phoneNumber.slice(-4);
      navigate(updateCompletePath);
    } else if (data?.error.includes('412')) {
      setSsnError('SSN does not match. Please try again.');
    } else if (data?.error.includes('403')) {
      window.location.href = accountLockedPath;
    }

    setLoading(false);
  }

  return (
    <UpdatePhoneComponent
      ssnError={ssnError}
      loading={loading}
      handleUpdate={handleUpdate}
      BackComponent={() => (
        <Link id='back' navigate={navigate} to={MFA_VERIFY_PHONE}>
          Back
        </Link>
      )}
    />
  );
}

export default UpdatePhone;
